import React from 'react';
import { Link } from 'react-router-dom';
import SimpleHeader from '../components/SimpleHeader';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';
import { Clock, Calendar } from 'lucide-react';

const BlogListPage = () => {
  const blogPosts = [
    {
      slug: 'permaculture-saves-money',
      title: '7 Ways Permaculture Thinking Saves You Money (Without Growing a Single Plant)',
      excerpt: "Permaculture isn't just about growing food — it's a design philosophy that can radically change how you spend. Here are 7 principles that will permanently rewire your relationship with money.",
      date: 'April 5, 2026',
      readTime: '6 min read'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F5F1E8]">
      <SimpleHeader />
      
      <main className="pt-24 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-[#2C1810] mb-4">
            SpendLess Blog
          </h1>
          
          <p className="text-[#5A5046] text-xl mb-16">
            Permaculture-inspired thinking for your money. No fluff, no guilt.
          </p>
          
          <div className="space-y-8">
            {blogPosts.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`}>
                <Card className="bg-white border-none shadow-md hover:shadow-xl transition-all p-8 group">
                  <div className="flex items-center gap-4 text-sm text-[#5A5046] mb-4">
                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4" />
                      <span>{post.date}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4" />
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                  
                  <h2 className="text-3xl font-bold text-[#2C1810] mb-4 group-hover:text-[#6B7A5C] transition-colors">
                    {post.title}
                  </h2>
                  
                  <p className="text-[#5A5046] leading-relaxed mb-4">
                    {post.excerpt}
                  </p>
                  
                  <span className="text-[#6B7A5C] font-semibold group-hover:underline">
                    Read article →
                  </span>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default BlogListPage;